// 用户详情
export default {
    heard_title: "用户详情",
    heard_btn: "返回",
    // userInfo
    recharge_btn: "充值",
    tl_nickName: "昵称",
    tl_age: "年龄",
    tl_gender: "性别",
    tl_address: "城市",
    tl_level: "等级",
    tl_experience: "经验值",
    tl_createTime: "注册时间",
    tl_activeityTime: "上次登录时间",
    tl_channel: "渠道",
    tl_storeName: "门店",
    tp_store: "请选择",
    // statistic表格
    t_title_statistics: "统计信息",
    tl_balance: "账户余额",
    tl_rechargeAmout: "充值总额",
    tl_rechargeQuantity: "充值次数",
    tl_consumeQuantity: "消费次数",
    tl_orderQuantity: "订单数量",
    tl_frequency: "来访天数",
    tl_gameQuantity: "参赛次数",
    tl_refundOrderQuantity: "退款记录",
    tl_evaluateQuantity: "评价",
    tl_couponQuantity: "优惠券",
    tl_inviteQuantity: "邀请好友",
    // tab1
    tab_label_game: "参赛记录",
    tab_tl_frequency: "来访",
    tab_tl_sequence: "第几次参赛",
    tab_tl_syncDate: "日期",
    tab_tl_syncTime: "时间",
    tab_tl_scheduleCode: "场次",
    tab_tl_scheduleTitle: "项目",
    tab_tl_bestTime: "最佳成绩",
    tab_tl_ranking: "名次",
    tab_tl_originalExperience: "经验值",
    tab_btn_viewReport: "查看成绩",
    // tab2
    tab_label_recharge: "充值记录",
    tab_tl_rank: "排行",
    tab_tl_payTime: "时间",
    tab_tl_amount: "金额",
    tab_tl_balance: "余额",
    // tab3
    tab_label_order: "订单记录",
    tab_tl_no: "订单编号",
    tab_tl_createTime: "创建时间",
    tab_tl_acount: "用户账号",
    tab_tl_totalAmount: "订单金额",
    tab_tl_status: "订单状态",
    tab_tl_payWay: "支付方式",
    tab_tl_regChannel: "渠道",
    // 成绩表
    dt_reportTable: "成绩列表",
    dl_number: "第几圈",
    dl_report: "成绩",
    dl_experience: "经验值",
    // 支付提示
    dl_payAmount: "支付金额:",
    dl_payUnit: "元",
    dl_payWay: "支付方式",
    // 充值表单
    dt_recharge: "充值",
    dl_rechargeAmount: "充值金额",
    dp_rechargeAmount: "请输入充值金额",
    dl_payModel: "支付方式",
    dp_payModel: "请选择支付方式",
    ol_wechatpay: "微信支付",
    ol_cash: "现金",
    ol_pos: "刷卡",
    ol_other: "其他",
    ol_alipay: "支付宝",
    dl_authCode: "付款码:",
    dp_authCode: "请使用扫码枪扫描付款码",
    dl_rewardAmount: "充值活动:",
    dp_rewardAmount: "请选择",
    dl_dicount: "会员卡充值:",
    dp_dicount: "请选择",
    pay_tip1: "支付成功",
    pay_tip2: "支付失败",
    pay_tip3: "支付结果未知",
    pay_step1: "确定",
    pay_step2: "重新支付",
    em_authCode: "付款码不能为空",
    ft_channel_mini: "微信小程序",
    ft_channel_web: "电脑网页",
    ft_payWay_wechartpay: "微信支付",
    ft_payWay_alipay: "支付宝",
    ft_payWay_wallet: "会员卡",
    ft_payWay_card: "会员卡",
    ft_payWay_cash: "现金",
    ft_payWay_pos: "刷卡",
    ft_payWay_other: "其他",
    ft_status_notConfirmed: "待付款",
    ft_status_confirmed: "待使用",
    ft_status_close: "已关闭",
    ft_status_completed: "已完成",
    ft_status_canceled: "已取消"
};
